// eslint-disable-next-line import/no-cycle
import {
  GET_BASE_SETTINGS,
  BASE_SETTINGS,
  BASE_SETTING_ERROR,
  BASE_SETTING_SUCCESS,
  UPDATE_BASE_SETTING,
} from 'redux/actions';

export const getBaseSettings = (filter) => {
  return {
    type: GET_BASE_SETTINGS,
    payload: { filter },
  };
};

export const updateBaseSetting = (id, key, value, settings) => {
  return {
    type: UPDATE_BASE_SETTING,
    payload: { id, key, value, settings },
  };
};

export const baseSettings = (settings) => {
  return {
    type: BASE_SETTINGS,
    payload: settings,
  };
};

export const baseSettingSuccess = (message) => ({
  type: BASE_SETTING_SUCCESS,
  payload: { message },
});
export const baseSettingError = (message) => ({
  type: BASE_SETTING_ERROR,
  payload: { message },
});
